module.exports = __webpack_public_path__ + "static/media/wait.c805d9fe.png";